export default __webpack_public_path__ + "static/hydrokon-03b7ba0ba5b7aea7a45623260fb74c97.png";